/** The exchange's month letters, January to December. */
export const MONTH_LETTERS = [
  { letter: 'F', name: 'Jan' },
  { letter: 'G', name: 'Feb' },
  { letter: 'H', name: 'Mar' },
  { letter: 'J', name: 'Apr' },
  { letter: 'K', name: 'May' },
  { letter: 'M', name: 'Jun' },
  { letter: 'N', name: 'Jul' },
  { letter: 'Q', name: 'Aug' },
  { letter: 'U', name: 'Sep' },
  { letter: 'V', name: 'Oct' },
  { letter: 'X', name: 'Nov' },
  { letter: 'Z', name: 'Dec' },
];

/** "HKNUZ" as "Mar, May, Jul, Sep, Dec". */
export function monthNames(letters: string) {
  return MONTH_LETTERS.filter((m) => letters.includes(m.letter))
    .map((m) => m.name)
    .join(', ');
}
